import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Perfil/getPerfil`, method: 'GET', body: null, token: token})
}
